import { render, staticRenderFns } from "./UpsiStatusCell.vue?vue&type=template&id=6eb40f8e"
import script from "./UpsiStatusCell.vue?vue&type=script&lang=js"
export * from "./UpsiStatusCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports